<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal-popin"
     aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" bsModal>
    <div class="modal-content">
      <div class="block block-themed block-transparent mb-0">
        <div class="block-header bg-primary-dark">
          <h3 class="block-title">Details</h3>
          <div class="block-options">
            <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close"
                    (click)="hideChildModal()">
              <i class="si si-close"></i>
            </button>
          </div>
        </div>

        <!-- -->
        <div class="block-content block-content-full" *ngIf="booking != null">

          <div class="row">
            <div class="col-lg-12">
              <h5>Booking and Offer Details</h5>

              <div class="row">
                <div class="col-md-2">Price (Total):</div>
                <div class="col-md-4 text-right">{{ offer.price.total }} {{ offer.price.currency }}</div>
              </div>
              <div class="row">
                <div class="col-md-2">Deposit:</div>
                <div
                  class="col-md-4 text-right">{{ booking.paymentStateDetails.amountOfDepositPayment }} {{ offer.price.currency }}
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">Percentages:</div>
                <div
                  class="col-md-4 text-right">{{ offer.paymentPolicy.depositDetails.readableData }}
                </div>
              </div>

              <div class="row">
                <div class="col-12">&nbsp;</div>
              </div>

              <div class="row" *ngIf="bookingLogs.length != 0">
                <div class="col-12">
                  <h6>Recent Total Price Changes</h6>
                  <table class="table table-responsive table-sm table-striped">
                    <thead>
                    <tr>
                      <th>Date</th>
                      <th>Price Before</th>
                      <th>Price After</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let logEntry of bookingLogs">
                      <td>{{ logEntry.createdAt }}</td>
                      <td>{{ logEntry.totalBefore }}</td>
                      <td>{{ logEntry.totalAfter }}</td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>

              <div class="row" *ngIf="bookingLogs.length != 0">
                <div class="col-12">&nbsp;</div>
              </div>

              <div class="row">
                <div class="col-12">
                  <h6>Cancellation Details</h6>
                  <span *ngIf="offer.cancellationPolicy.noCancellation === true">This is a non-refundable rate!</span>
                  <span *ngIf="offer.cancellationPolicy.anytime === true">This offer can be cancelled for free at anytime!</span>
                  <span
                    *ngIf="offer.cancellationPolicy.numberOfDays != null">This offer can be cancelled for free {{ offer.cancellationPolicy.numberOfDays }}
                    day(s) prior to arrival! Calculated Deadline: {{ offer.cancellationPolicy.calculatedDate }}</span>
                </div>
              </div>

              <div class="row"
                   *ngIf="offer.cancellationPolicy.grading != null && offer.cancellationPolicy.grading.length > 0">
                <div class="col-12">&nbsp;</div>
              </div>

              <div class="row"
                   *ngIf="offer.cancellationPolicy.grading != null && offer.cancellationPolicy.grading.length > 0">
                <div class="col-12">
                  <h6>Cancellation Grading</h6>
                  <table class="table table-responsive table-sm table-striped"
                         *ngIf="offer.cancellationPolicy.grading != null && offer.cancellationPolicy.grading.length > 0">
                    <thead>
                    <tr>
                      <th>Days before arrival</th>
                      <th>Calculated Date</th>
                      <th>Percentage</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let grading of offer.cancellationPolicy.grading">
                      <td>{{ grading.daysBeforeArrival }}</td>
                      <td>{{ grading.calculatedDate }}</td>
                      <td>{{ grading.percentage }}%</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-12">&nbsp;</div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <h5>User Payments
                <button (click)="openKitchenWindow(booking.request)" class="btn btn-sm btn-alt-info"><i
                  class="fa fa-search"></i></button>
              </h5>

              <div class="row" *ngIf="booking.paymentStateDetails.isShortTermBooking === true">
                <div class="col-12">
                  <div class="alert alert-info">
                    <strong>Info:</strong> This is a short term booking!
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="booking.paymentStateDetails.mandatoryFullPayment === true">
                <div class="col-12">
                  <div class="alert alert-info">
                    <strong>Info:</strong> This is a mandatory full payment!
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="booking.paymentStateDetails.userSelectedFullPayment === true">
                <div class="col-12">
                  <div class="alert alert-info">
                    <strong>Info:</strong> User has selected full payment!
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <table class="table table-responsive table-sm table-striped">
                    <thead>
                    <tr>
                      <th style="min-width:100px" class="text-left">Value</th>
                      <th class="text-left">Percentage</th>
                      <th>Deposit</th>
                      <th>Required</th>
                      <th style="min-width:100px">Deadline</th>
                      <th style="min-width:100px">State</th>
                      <th style="min-width:100px">Refund</th>
                      <th></th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let paymentStateDetails of booking.paymentStateDetails.payments">
                      <td
                        class="text-right">{{ paymentStateDetails.valueRequired.toFixed(2) }} {{ paymentStateDetails.currency }}
                      </td>
                      <td class="text-right">{{ paymentStateDetails.percentage }}%</td>
                      <td class="text-center">
                        <i class="fa fa-check" *ngIf="paymentStateDetails.isTripmakeryDeposit === true"></i>
                        <span *ngIf="paymentStateDetails.containsTripmakeryDeposit === true"><i
                          class="fa fa-check-circle-o"></i></span>
                      </td>
                      <td class="text-center">
                        <i class="fa fa-check" *ngIf="paymentStateDetails.requiresPayment === true"></i>
                        <i class="fa times" *ngIf="paymentStateDetails.requiresPayment === false"></i>
                      </td>
                      <td style="min-width:200px">{{ paymentStateDetails.deadline }}
                        <ng-template #popTemplate>
                          <div [innerHtml]="paymentStateDetails.deadlineChangesInHtml"></div>
                        </ng-template>
                        <span
                          *ngIf="paymentStateDetails.deadlineChanges != null && paymentStateDetails.deadlineChanges.length != 0"
                          [popover]="popTemplate"
                          triggers="mouseenter:mouseleave"
                        >
                          <br>
                          <em>({{ paymentStateDetails.deadlineChanges.length }}
                            Changes)</em>
                        </span>
                      </td>
                      <td>{{ paymentStateDetails.paymentState }}
                      </td>
                      <td>
                        <span *ngIf="paymentStateDetails.refundPayment === false"><em>No refund planned</em></span>
                        <ng-container *ngIf="paymentStateDetails.refundPayment === true">
                          <span *ngIf="paymentStateDetails.refundCompleted === true">
                            {{ paymentStateDetails.amountRefunded }} {{ paymentStateDetails.currency }} refund completed
                          </span>
                          <ng-container *ngIf="paymentStateDetails.refundCompleted === false">
                            <span class="mr-2" *ngIf="paymentStateDetails.refundForPaymentApproved === true && paymentStateDetails.refundForPaymentSent === false">
                              {{ paymentStateDetails.amountToRefund }} {{ paymentStateDetails.currency }} refund approved
                            </span>
                            <ng-container *ngIf="!paymentStateDetails.refundForPaymentApproved && paymentStateDetails.refundForPaymentSent === false">
                              {{ paymentStateDetails.amountToRefund }} {{ paymentStateDetails.currency }}
                              refund pending approval
                            </ng-container>
                            <ng-container *ngIf="paymentStateDetails.refundForPaymentSent === true ">
                              Refund sent (Cancellable in Mollie)
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </td>
                      <td>
                        <ng-container *ngIf="paymentStateDetails.refundPayment === true">
                          <ng-container *ngIf="paymentStateDetails.refundCompleted === false">
                            <ng-container *ngIf="paymentStateDetails.refundForPaymentSent === false">
                              <button (click)="toggleRefundApproval(paymentStateDetails)"
                                class="btn btn-sm"
                                [disabled]="refundApprovalsLoading[paymentStateDetails._id]"
                                [ngClass]="{
                                  'btn-success': !paymentStateDetails.refundForPaymentApproved,
                                  'btn-danger': paymentStateDetails.refundForPaymentApproved === true
                                }">
                                <ng-container *ngIf="paymentStateDetails.refundForPaymentApproved === true">
                                  Undo approval
                                </ng-container>
                                <ng-container *ngIf="!paymentStateDetails.refundForPaymentApproved">
                                  Approve refund
                                </ng-container>
                              </button>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </td>
                      <td>
                        <a href="{{paymentStateDetails.paymentUrl}}" class="btn btn-alt-info btn-sm"
                           *ngIf="paymentStateDetails.paymentUrl != null" target="_blank"><i
                          class="fa fa-search"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">&nbsp;</div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <h5>Partner Payments
                <button (click)="openAdminToolWindow(booking._id)" class="btn btn-sm btn-alt-info"><i
                  class="fa fa-search"></i></button>
              </h5>

              <div class="row"
                   *ngIf="booking.autoPayoutDetails == null || booking.autoPayoutDetails.isEnabled === false">
                <div class="col-12">
                  <div class="alert alert-warning">
                    <strong>Attention:</strong> Partner Payouts have been disabled or were not available for this
                    booking!
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="booking.autoPayoutDetails != null &&
              booking.autoPayoutDetails.payouts != null &&
              booking.autoPayoutDetails.payouts.length > 0">
                <div class="col-lg-12">
                  <table style="width:100%" class="table table-responsive table-sm table-striped">
                    <thead>
                    <tr>
                      <th class="text-left" style="min-width:100px">Value</th>
                      <th style="min-width:100px">Payment State</th>
                      <th style="min-width:100px">Scheduled</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let payoutDetails of booking.autoPayoutDetails.payouts">
                      <td
                        class="text-right">{{ payoutDetails.amount.toFixed(2) }} {{ payoutDetails.currency }}
                      </td>
                      <td style="min-width:200px">{{ payoutDetails.paymentState }}</td>
                      <td style="min-width:200px">{{ payoutDetails.scheduledFor }}</td>
                      <td>
                        <a href="{{payoutDetails.paymentUrl}}" class="btn btn-alt-info btn-sm"
                           *ngIf="payoutDetails.paymentUrl != null" target="_blank"><i class="fa fa-search"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">&nbsp;</div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <h5>Partner Refunds</h5>

              <div class="row"
                   *ngIf="booking.autoPayoutDetails == null ||
                   booking.autoPayoutDetails.partnerReturnTransferPayments == null ||
                   booking.autoPayoutDetails.partnerReturnTransferPayments.length === 0">
                <div class="col-12">
                  <div class="alert alert-info">
                    <strong>Information:</strong> No refunds are currently planned.
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="booking.autoPayoutDetails != null &&
              booking.autoPayoutDetails.partnerReturnTransferPayments != null &&
              booking.autoPayoutDetails.partnerReturnTransferPayments.length > 0">
                <div class="col-lg-12">
                  <table style="width:100%" class="table table-responsive table-sm table-striped">
                    <thead>
                    <tr>
                      <th class="text-left" style="min-width:100px">Value</th>
                      <th class="text-left" style="min-width:150px">Value with Provision</th>
                      <th style="min-width:100px">Refund State</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let refundDetails of booking.autoPayoutDetails.partnerReturnTransferPayments">
                      <td
                        class="text-right">{{ refundDetails.amount.toFixed(2) }} {{ refundDetails.currency }}
                      </td>
                      <td
                        class="text-right">{{ refundDetails.amountWithProvision != null ? refundDetails.amountWithProvision.toFixed(2) : '-' }} {{ refundDetails.currency }}
                      </td>
                      <td style="min-width:200px">{{ refundDetails.paymentState }}</td>
                      <td>
                        <a href="{{refundDetails.paymentUrl}}" class="btn btn-alt-info btn-sm"
                           *ngIf="refundDetails.paymentUrl != null" target="_blank"><i class="fa fa-search"></i></a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              &nbsp;
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <h5>Comments</h5>
              <div class="row">
                <div class="col-lg-12">
                  <span
                    *ngIf="booking.internalInfo == null || booking.internalInfo.adminComments == null || booking.internalInfo.adminComments.length === 0"><em>There aren't any comments yet</em><br><br></span>
                  <table class="table table-responsive"
                         *ngIf="booking.internalInfo != null && booking.internalInfo.adminComments != null && booking.internalInfo.adminComments.length !== 0">
                    <thead>
                    <tr>
                      <th>Date</th>
                      <th>Comment</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let comment of booking.internalInfo.adminComments">
                      <td style="min-width:200px">{{ comment.createdAt }}</td>
                      <td style="width:90%">{{ comment.comment }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <form [formGroup]="formAddComment" (ngSubmit)="addComment()">
                    <textarea class="form-control" formControlName="comment" placeholder="Please enter your comment.."
                              name="comment" rows="4"></textarea>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mt-5">
                  <button class="btn btn-info" (click)="addComment()">Submit</button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- -->


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-alt-secondary" data-dismiss="modal" (click)="hideChildModal()">Close
        </button>
      </div>
    </div>
  </div>
</div>

